import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Asset } from './../../../../../_shared/model/asset.model';
import { HelperService } from './../../../../../_shared/services/helper.service';
import { SetCalendarFilter } from './../../../../../_shared/state/base/base.actions';
import { BaseState } from './../../../../../_shared/state/base/base.state';

@Component({
    selector: 'main-cal-assets',
    templateUrl: './main-cal-assets.component.html',
    styles: [],
})
export class MainCalAssetsComponent implements OnInit {
    constructor(
        private store: Store,
        private helper: HelperService,
    ) {}
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public selectedAssets: any[];
    public guiSettings;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public allAssetGroups: any;
    public allAssets: Asset[];
    private onDestroy$ = new Subject<void>();

    @Select(BaseState.GetUserSettings)
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    userSettings: Observable<any>;

    @Input() set setAssets(value: Asset[]) {
        if (value) {
            this.allAssets = value;
            this.allAssetGroups = this.helper.createAssetGroups(this.allAssets);
        }
    }

    ngOnInit() {
        this.userSettings.pipe(takeUntil(this.onDestroy$)).subscribe(res => {
            if (res) {
                this.guiSettings = res.calendar;
                this.selectedAssets = _.get(this.guiSettings, 'filter.selectedAssets', []);
            }
        });
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public changeAssetFilter(event, value): void {
        const tmpAssets = Object.assign([], this.selectedAssets);
        if (event.target.checked) {
            tmpAssets.push(value);
        } else {
            tmpAssets.splice(this.selectedAssets.indexOf(value), 1);
        }
        this.selectedAssets = tmpAssets;
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.selectedAssets = this.selectedAssets;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }

    public checkIfSelectedAsset(asset: Asset): boolean {
        if (this.selectedAssets.find(ass => ass.id === asset.id)) {
            return true;
        }
        return false;
    }

    public allSelected(type: string): boolean {
        const selectedCount = this.selectedAssets.filter(asset => asset.assetType === type).length;
        const allCount = this.allAssets.filter(asset => asset.assetType === type).length;
        return selectedCount === allCount;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onChangeSelectLocal(assetGroupData: Asset[], event: any, assetGroupType: string): void {
        //resetira celo skupino
        this.selectedAssets = this.selectedAssets.filter(asset => asset.assetType !== assetGroupType);
        //nafila, če je checked
        assetGroupData.forEach(asset => {
            if (event.target.checked) {
                this.selectedAssets.push(asset);
            }
        });
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.selectedAssets = this.selectedAssets;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public selectAllAssets(event: any) {
        // resetiraj ali aktiviraj vse assete
        if (!event.target.checked) {
            this.selectedAssets = [];
        } else {
            this.selectedAssets = this.allAssets;
        }
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.selectedAssets = this.selectedAssets;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }
}
